export enum StoreStatusEnum {
    Regular = 1,
    Busy = 2,
    Pause = 3,
    Rejected = 4,
    Approved = 5
}
